import React from "../../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../../api/spacing/useSpacing.mjs.mjs";
import { pickComponentCommonProps, pickDataProps, pickAriaProps, } from "../../../interfaces/commonProps.mjs.mjs";
import { StyledDividerWrap, StyledDisclamer, StyledDisclamerWrapper, } from "./ExtendedSelectionToolbar.styles.mjs.mjs";
export const ExtendedSelectionToolbar = React.forwardRef(function ExtendedSelectionToolbar(props, ref) {
    const commonProps = pickComponentCommonProps(props);
    const dataProps = pickDataProps(props);
    const ariaProps = pickAriaProps(props);
    const outerSpacing = useSpacing(props);
    return (React.createElement(StyledDividerWrap, { ...commonProps, ref: ref, outerSpacing: outerSpacing, ...dataProps, ...ariaProps },
        React.createElement(StyledDisclamerWrapper, null,
            React.createElement(StyledDisclamer, null, props.disclamerElement),
            props.disclamerIconElement)));
});
//# sourceMappingURL=ExtendedSelectionToolbar.mjs.mjs.map